interface SentimentBadgeProps {
  classification: string | null;
  score?: number | null;
  size?: 'sm' | 'md';
}

export default function SentimentBadge({ classification, score, size = 'md' }: SentimentBadgeProps) {
  if (!classification) {
    return null;
  }

  const colors = {
    Positive: 'bg-green-100 text-green-800 border-green-300',
    Neutral: 'bg-gray-100 text-gray-800 border-gray-300',
    Negative: 'bg-red-100 text-red-800 border-red-300',
  };

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
  };

  const colorClass = colors[classification as keyof typeof colors] || colors.Neutral;
  const sizeClass = sizeClasses[size];

  return (
    <span className={`inline-flex items-center rounded-full border ${colorClass} ${sizeClass} font-medium`}>
      {classification}
      {score !== null && score !== undefined && (
        <span className="ml-1 opacity-75">({score.toFixed(2)})</span>
      )}
    </span>
  );
}
